<div class="dashboard-card card">
  <div class="card-body dashboard-card-content">
    <div class="card-title">
      <span class="title" translate>SUMMARY</span>
    </div>
    <cult-invoice-statistics-chart [preConditions]="preConditions"></cult-invoice-statistics-chart>
  </div>
</div>
